/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';

import { AccountsProcessesService } from './services/AccountsProcessesService';
import { AiProcessesService } from './services/AiProcessesService';
import { BrandsService } from './services/BrandsService';
import { BrandsProcessesService } from './services/BrandsProcessesService';
import { CompaniesService } from './services/CompaniesService';
import { CompaniesProcessesService } from './services/CompaniesProcessesService';
import { CompanyAttributesService } from './services/CompanyAttributesService';
import { CompanyAttributeSetsService } from './services/CompanyAttributeSetsService';
import { CompanyAttributesProcessesService } from './services/CompanyAttributesProcessesService';
import { CompanyCreditsService } from './services/CompanyCreditsService';
import { CopilotAuditLogsService } from './services/CopilotAuditLogsService';
import { CopilotBillingEventsService } from './services/CopilotBillingEventsService';
import { CopilotsService } from './services/CopilotsService';
import { CreditAlertConfigsService } from './services/CreditAlertConfigsService';
import { DemoDataCollectionsService } from './services/DemoDataCollectionsService';
import { EinsService } from './services/EinsService';
import { EinsProcessesService } from './services/EinsProcessesService';
import { EnterprisesService } from './services/EnterprisesService';
import { EnterprisesProcessesService } from './services/EnterprisesProcessesService';
import { HirePermissionsProcessesService } from './services/HirePermissionsProcessesService';
import { PaymentInvoicesService } from './services/PaymentInvoicesService';
import { ProductAgentNetsService } from './services/ProductAgentNetsService';
import { ServiceService } from './services/ServiceService';
import { StripeService } from './services/StripeService';
import { SuperuserBillingAdminService } from './services/SuperuserBillingAdminService';
import { SuperuserCompanyContextService } from './services/SuperuserCompanyContextService';
import { SuperuserOutcomeCreditConfigsService } from './services/SuperuserOutcomeCreditConfigsService';
import { SuperuserPoolAdminService } from './services/SuperuserPoolAdminService';
import { TranslationTerminologiesService } from './services/TranslationTerminologiesService';
import { TranslationTerminologiesProcessesService } from './services/TranslationTerminologiesProcessesService';
import { WarehouseConnectionConfigsService } from './services/WarehouseConnectionConfigsService';
import { WarehouseConnectionConfigsProcessesService } from './services/WarehouseConnectionConfigsProcessesService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class AppClient {

  public readonly accountsProcesses: AccountsProcessesService;
  public readonly aiProcesses: AiProcessesService;
  public readonly brands: BrandsService;
  public readonly brandsProcesses: BrandsProcessesService;
  public readonly companies: CompaniesService;
  public readonly companiesProcesses: CompaniesProcessesService;
  public readonly companyAttributes: CompanyAttributesService;
  public readonly companyAttributeSets: CompanyAttributeSetsService;
  public readonly companyAttributesProcesses: CompanyAttributesProcessesService;
  public readonly companyCredits: CompanyCreditsService;
  public readonly copilotAuditLogs: CopilotAuditLogsService;
  public readonly copilotBillingEvents: CopilotBillingEventsService;
  public readonly copilots: CopilotsService;
  public readonly creditAlertConfigs: CreditAlertConfigsService;
  public readonly demoDataCollections: DemoDataCollectionsService;
  public readonly eins: EinsService;
  public readonly einsProcesses: EinsProcessesService;
  public readonly enterprises: EnterprisesService;
  public readonly enterprisesProcesses: EnterprisesProcessesService;
  public readonly hirePermissionsProcesses: HirePermissionsProcessesService;
  public readonly paymentInvoices: PaymentInvoicesService;
  public readonly productAgentNets: ProductAgentNetsService;
  public readonly service: ServiceService;
  public readonly stripe: StripeService;
  public readonly superuserBillingAdmin: SuperuserBillingAdminService;
  public readonly superuserCompanyContext: SuperuserCompanyContextService;
  public readonly superuserOutcomeCreditConfigs: SuperuserOutcomeCreditConfigsService;
  public readonly superuserPoolAdmin: SuperuserPoolAdminService;
  public readonly translationTerminologies: TranslationTerminologiesService;
  public readonly translationTerminologiesProcesses: TranslationTerminologiesProcessesService;
  public readonly warehouseConnectionConfigs: WarehouseConnectionConfigsService;
  public readonly warehouseConnectionConfigsProcesses: WarehouseConnectionConfigsProcessesService;

  public readonly request: BaseHttpRequest;

  constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? 'http://localhost:8101',
      VERSION: config?.VERSION ?? '1.0.0',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });

    this.accountsProcesses = new AccountsProcessesService(this.request);
    this.aiProcesses = new AiProcessesService(this.request);
    this.brands = new BrandsService(this.request);
    this.brandsProcesses = new BrandsProcessesService(this.request);
    this.companies = new CompaniesService(this.request);
    this.companiesProcesses = new CompaniesProcessesService(this.request);
    this.companyAttributes = new CompanyAttributesService(this.request);
    this.companyAttributeSets = new CompanyAttributeSetsService(this.request);
    this.companyAttributesProcesses = new CompanyAttributesProcessesService(this.request);
    this.companyCredits = new CompanyCreditsService(this.request);
    this.copilotAuditLogs = new CopilotAuditLogsService(this.request);
    this.copilotBillingEvents = new CopilotBillingEventsService(this.request);
    this.copilots = new CopilotsService(this.request);
    this.creditAlertConfigs = new CreditAlertConfigsService(this.request);
    this.demoDataCollections = new DemoDataCollectionsService(this.request);
    this.eins = new EinsService(this.request);
    this.einsProcesses = new EinsProcessesService(this.request);
    this.enterprises = new EnterprisesService(this.request);
    this.enterprisesProcesses = new EnterprisesProcessesService(this.request);
    this.hirePermissionsProcesses = new HirePermissionsProcessesService(this.request);
    this.paymentInvoices = new PaymentInvoicesService(this.request);
    this.productAgentNets = new ProductAgentNetsService(this.request);
    this.service = new ServiceService(this.request);
    this.stripe = new StripeService(this.request);
    this.superuserBillingAdmin = new SuperuserBillingAdminService(this.request);
    this.superuserCompanyContext = new SuperuserCompanyContextService(this.request);
    this.superuserOutcomeCreditConfigs = new SuperuserOutcomeCreditConfigsService(this.request);
    this.superuserPoolAdmin = new SuperuserPoolAdminService(this.request);
    this.translationTerminologies = new TranslationTerminologiesService(this.request);
    this.translationTerminologiesProcesses = new TranslationTerminologiesProcessesService(this.request);
    this.warehouseConnectionConfigs = new WarehouseConnectionConfigsService(this.request);
    this.warehouseConnectionConfigsProcesses = new WarehouseConnectionConfigsProcessesService(this.request);
  }
}

